import _ from "lodash";

const validationSelectedPacs = (selectedPacs: string | number | null) => {
    const errors = {
        typeDeclaration: '',
    };

    if (_.isNil(selectedPacs) || selectedPacs === '') {
        errors.typeDeclaration = 'Le choix du projet est obligatoire pour continuer';
    }

    return _.pickBy(errors, (value) => value !== '');
}

export default validationSelectedPacs;